module.exports = __webpack_public_path__ + "img/28.a03ef8ee.png";